<section aria-hidden="true">
    <div class="hero-image"></div>
    <div class="hero-text">
      <div>Happy {{ currentDay() }},</div>
      <div>{{ firstName }}</div>
    </div>
  </section>